<template>
  <Loader v-if="isDataLoading"/>
  <div v-else>
    <Table
      :title="$t('views.devices.title')"
      :headers="backupsHeaders"
      :rows="backupsRows"
      :values="backups"
      @export="exportVolumetry"
      />
  </div>
</template>

<script>
import AVAMAR from '@/api/avamar';

import Loader from '@/components/Loader.vue';

export default {
  name: 'devices',
  components: {
    Table: () => import('@/components/Table'),
    Loader,
  },
  data() {
    return {
      isDataLoading: true,
      backupsHeaders: [
        {
          label: this.$t('views.devices.config.device'),
          field: 'device',
        },
        {
          label: this.$t('views.devices.config.rate'),
          field: 'success_rate',
        },
        {
          label: this.$t('views.devices.config.bytes'),
          field: 'total_protected_bytes',

        },
        {
          label: this.$t('views.devices.config.backup'),
          field: 'total_stored_backup',
        },
        {
          label: this.$t('views.devices.config.datetime'),
          field: 'last_backup_datetime',
        },
      ],
      backupsRows: [
        {
          value: row => row.device,
        },
        {
          value: row => row.success_rate,
        },
        {
          value: row => row.total_protected_bytes,
        },
        {
          value: row => row.total_stored_backup,
        },
        {
          value: row => row.last_backup_datetime,
        },
      ],
      backups: [],
    }
  },
  computed: {
  },
  created() {
    this.listBackups();
  },
  methods: {

    listBackups() {
      AVAMAR.volumetry().then(
        (res) => {
          this.isDataLoading = false;
          if (res.data && res.data.length) {
            this.backups = res.data;
          }
        },
      );
    },

    // filterValues(values) {
    //   this.backups = values
    // },

    exportVolumetry() {
      AVAMAR.exportVolumetry();
    },
  },
};
</script>
